// Theme accent palette. Overrides --primary / --ring / --brand-mark / sidebar
// via [data-accent] on <html>. Persisted to localStorage.

export type AccentKey =
  | 'amber'
  | 'cyan'
  | 'emerald'
  | 'violet'
  | 'rose'
  | 'blue'
  | 'lime'
  | 'magenta'
  | 'gray';

export interface AccentOption {
  key: AccentKey;
  label: string;
  hsl: string; // "H S% L%" — used for swatch background
}

export const ACCENT_OPTIONS: AccentOption[] = [
  { key: 'amber',   label: 'Amber',   hsl: '38 92% 55%' },
  { key: 'gray',    label: 'Gray',    hsl: '220 9% 75%' },
  { key: 'cyan',    label: 'Cyan',    hsl: '190 95% 50%' },
  { key: 'emerald', label: 'Emerald', hsl: '152 70% 45%' },
  { key: 'lime',    label: 'Lime',    hsl: '88 85% 55%' },
  { key: 'blue',    label: 'Blue',    hsl: '212 95% 62%' },
  { key: 'violet',  label: 'Violet',  hsl: '265 85% 68%' },
  { key: 'magenta', label: 'Magenta', hsl: '310 85% 62%' },
  { key: 'rose',    label: 'Rose',    hsl: '345 85% 62%' },
];

const STORAGE_KEY = 'accent-color';
const DEFAULT: AccentKey = 'amber';

export const getStoredAccent = (): AccentKey => {
  try {
    const v = localStorage.getItem(STORAGE_KEY) as AccentKey | null;
    if (v && ACCENT_OPTIONS.some((o) => o.key === v)) return v;
  } catch {
    /* ignore */
  }
  return DEFAULT;
};

export const applyAccent = (key: AccentKey) => {
  if (typeof document === 'undefined') return;
  document.documentElement.dataset.accent = key;
};

export const setAccent = (key: AccentKey) => {
  try {
    localStorage.setItem(STORAGE_KEY, key);
  } catch {
    /* ignore */
  }
  applyAccent(key);
  window.dispatchEvent(new CustomEvent('accent-changed', { detail: key }));
};
